/* global globalThis */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import 'react-confirm-alert/src/react-confirm-alert.css';
import status from "sdk/constants/actionStatus";
import QuizError from "./../components/Quiz/Loader/QuizError";
import { blockDeveloperTool } from 'sdk/common';
import QuizPlayground from '../components/Quiz/QuizPlayground';

import { useAnalyticsPageView, useQuizData } from "sdk/custom-hooks";
import { confirmAlert } from "react-confirm-alert";

/**
 * Quiz module entry module.
 * @param props
 * @returns {*}
 * @constructor
 */
function Quiz(props) {
    const { match } = props;
    const quizSubmissionObj = useSelector(state => state.quizSubmissionObj);
    const quizMode = match?.params?.mode;
    const slug = match?.params?.slug;
    const viewMode = (quizMode === 'view');

    //analytics
    useAnalyticsPageView();
    const quizData = useQuizData(slug, viewMode, quizMode);

    useEffect(() => {
        if (!viewMode) {
            blockDeveloperTool();
        }
    }, []);
    // if there is error then show the popup. // it is unlike case.
    useEffect(() => {
        if (quizSubmissionObj.status === status.ERROR) {
            confirmAlert({
                title: "Something went wrong",
                message: "Please try again later",
                buttons: [
                    {
                        label: 'Ok',
                        onClick: () => {
                            globalThis.location.href = '/';
                        }
                    }
                ]
            });
        }
    }, [ quizSubmissionObj ]);

    let isLoading = (quizData.status === status.PENDING);
    let isError = quizData.status === status.ERROR || (quizData?.questions?.length === 0 && quizData.status === status.SUCCESS);
    if (isError) {
        return (<QuizError/>);
    }
    return (
        <QuizPlayground
            quizMode={quizMode}
            viewMode={viewMode}
            slug={slug}
            singleCourseId={match?.params?.id}
            totalQuestions={quizData.totalQuestions}
            directionData={quizData?.directionData}
            directionId={quizData?.questions}
            quiz={quizData}
            isLoading={isLoading}/>
    );
}

Quiz.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            mode: PropTypes.string,
            slug: PropTypes.string,
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
};

export default Quiz;
